// PAGES
import ServerDashboard from './server-dashboard.js';

// Old pages
import UsersPage from './users/users.js';
import AccessRolesPage from './access_roles/access_roles.js';

// New pages
import NetworksPage from './networks/networks.js';
import SessionsPage from './sessions/sessions.js';
import DashboardPages from './dashboard_pages/index.js';
import CustomTables from './custom-tables/custom-tables.js';
import UserManage from './users-management/users-management.js';
import NewUsersPage from './new-users/users.js';
import AccessRoles from './access-roles/access-roles.js'; // New
import PrivilegesPage from './privileges/privileges.js'; // New
import ManageSubscriptions from './manage-subscriptions/manage-subscriptions.js';
import ManageSubscription from './manage-subscription/manage-subscription.js';
import NotificationTypes from './notification-types/notification-types.js';
import NotificationSetup from './notification-setup/notification-setup.js';
import Notifications from './notifications/notifications.js';

export default [
	ServerDashboard,
	UsersPage,
	AccessRolesPage,
	NetworksPage,
	SessionsPage,
	DashboardPages,
	CustomTables,
	UserManage,
	AccessRoles,
	NewUsersPage,
	PrivilegesPage,
	ManageSubscriptions,
	ManageSubscription,
	NotificationTypes,
	NotificationSetup,
	Notifications
];
